import { UseAsyncResponse, useAsync } from '@workday/wcp-cargo-react';
import { useState } from 'react';

/**
 * useAsyncState is a wrapper around useState that allows for an async initializer.
 * This is handy if you need an initial value for your state that is async.
 *
 * @param initializer async function that returns the initial state
 * @returns an object with the state, its loading status, error status, and a setter
 */
const useAsyncState = <T>(
  initializer: () => Promise<T>
): [T, React.Dispatch<React.SetStateAction<T>>, Pick<UseAsyncResponse<T>, 'loading' | 'error'>] => {
  // @ts-expect-error DEVEXTOOLS-1514: fix strictNullChecks rule violation
  const [value, setValue] = useState<T>(null);

  const useAsyncCall = useAsync<void>(async () => {
    const data = await initializer();
    setValue(data);
  }, []);

  return [
    value,
    setValue,
    {
      loading: useAsyncCall.loading,
      error: useAsyncCall.error,
    },
  ];
};

export default useAsyncState;
